import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/whw/Desktop/fugufish/vgw-website/frontend/src/app/[locale]/(front-desk)/(pages)/news/[category]/News.jsx");
